import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import ElementPc from "./components/ElementPc";
import ElementSmartphone from "./components/ElementSmartphone";

export default function GlobalMenu() {
  return (
    <Fragment>
      <Box sx={{ display: { xs: "none", sm: "block" } }}>
        <ElementPc />
      </Box>
      <Box sx={{ display: { xs: "block", sm: "none" } }}>
        <ElementSmartphone />
      </Box>
      <Outlet />
    </Fragment>
  );
}
